<template>
  <round :device="device" :isClose="false">
    <div>
      <img :src="state" style="width: 40px"/>
      <img :src="state" style="width: 40px"/>
      <img :src="state" style="width: 40px"/>
    </div>
    <div slot="footer" class="footer">
      <div @click="changeState('open')">
        <div>
          <img :src="icon.open" style="width: 55px"/>
        </div>
        <div>
          <span>打开</span>
        </div>
      </div>
      <!-- <div @click="changeState('paused')">
        <div>
          <img :src="icon.paused" style="width: 55px">
        </div>
        <div>
          <span>暂停</span>
        </div>
      </div> -->
      <div @click="changeState('close')">
        <div>
          <img :src="icon.close" style="width: 55px"/>
        </div>
        <div>
          <span>关闭</span>
        </div>
      </div>
      <div>
          <el-dropdown @command="handleCommand" placement="bottom-start" trigger="click">
            <span class="el-dropdown-link">
                   <div>
                  <span class="radius" more >
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  </div>
                  <div>
                    <span>更多</span>
                  </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">修改</el-dropdown-item>
              <el-dropdown-item command="c">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import { Message } from 'element-ui'
import api from '@/model/device'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Curtain',
  data () {
    return {}
  },
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState(['groups']),
    state () {
      if (this.device.state.state) {
        return require('@/assets/images/device/curtain/device_curtain_e.png')
      } else {
        return require('@/assets/images/device/curtain/device_curtain.png')
      }
    },
    icon () {
      let icon = {
        open: require('@/assets/images/device/curtain/dk.png'),
        paused: require('@/assets/images/device/curtain/zt.png'),
        close: require('@/assets/images/device/curtain/gb.png')
      }
      if (this.device.state.state === 2) {
        icon.close = require('@/assets/images/device/curtain/gb-k.png')
      } else if (this.device.state.state === 1) {
        icon.open = require('@/assets/images/device/curtain/dk-k.png')
      } else if (this.device.state.state === 0) {
        icon.paused = require('@/assets/images/device/curtain/zt-k.png')
      }
      return icon
    }
  },
  components: {
    Round
  },
  methods: {
    ...mapActions(['updateGroups']),
    async changeState (state) {
      try {
        await api.batchControl('curtain', state, '', this.device['include'])
      } catch (e) {
        Message.error(e.message)
      }
    },
    async handleCommand (command) {
      if (command === 'a') {
        this.$router.push({ name: 'lightDetail', params: { id: this.device.id, device: this.device, group: true } })
      } else if (command === 'b') {
        let index = this.groups.findIndex(item => this.device['name'] === item.name && JSON.stringify(item.listId) === JSON.stringify(this.device['include']))
        this.$router.push({ name: 'curtain', params: { index, desc: this.device['desc'], name: this.device['name'], include: this.device['include'] } })
      } else if (command === 'c') {
        const groups = this.groups.filter(item => item.name !== this.device.name && JSON.stringify(item.listId) !== JSON.stringify(this.device['include']))
        const result = await this.updateGroups(groups)
        if (result && result.code === 1) {
          Message.success('删除成功！')
        } else {
          Message.warning('删除失败！')
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    > div > div {
      height: 55px;
    }
    img {
      cursor: pointer;
    }
  }
    .radius {
      display: inline-block;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 50%;
    }

    .radius[more] {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 16px 2px rgba(85, 85, 85, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
    }

    .radius[more] > span {
      display: inline-block;
      background: rgba(85, 85, 85, 1);
      border-radius: 50%;
      height: 4px;
      width: 4px;
      margin-right: 4px;
    }

    .radius[more] > span:last-child {
      margin-right: 0;
    }

    .radius[selected] {
      width: 41px;
      height: 41px;
      border: 2px solid #e5e5e5;
    }
}
</style>
